/**
 * Login feature strings.
 *
 * Namespace: login
 */
export const login = {
  // Page
  page: {
    title: "Bejelentkezés",
    subtitle: "Jelentkezzen be a fiókjába",
    subtitleReturn: "Jelentkezzen be a folytatáshoz",
    subtitleFirstLogin: "Első bejelentkezés",
    noAccount: "Nincs még fiókja?",
    createAccount: "Regisztráljon",
    forgotPassword: "Elfelejtett jelszó?",
  },

  // Email step
  email: {
    label: "Email cím",
  },

  // Whitelist check step
  whitelistCheck: {
    continue: "Tovább email címmel",
    error: "Hiba történt. Kérjük, próbálja újra.",
  },

  // Registration step
  register: {
    helperText: "Adja meg a nevét az aktiváló e-mail küldéséhez.",
    familyName: "Vezetéknév",
    familyNamePlaceholder: "pl. Kovács",
    givenName: "Keresztnév",
    givenNamePlaceholder: "pl. János",
    leckeAcceptPrivacyPolicy: "Elolvastam és elfogadom a",
    leckePrivacyPolicyLink: "Lecke Adatkezelési tájékoztatóját",
    googleAcceptPrivacyPolicy: "Elfogadom a",
    googlePrivacyPolicyLink: "Google Adatvédelmi irányelveit",
    googleAcceptTermsOfService: "Elfogadom a",
    googleTermsOfServiceLink: "Google Általános szerződési feltételeit",
    submit: "Aktiváló e-mail küldése",
    errors: {
      familyNameRequired: "A vezetéknév megadása kötelező.",
      givenNameRequired: "A keresztnév megadása kötelező.",
      apiError: "Hiba történt. Kérjük, próbálja újra.",
      googlePrivacyPolicyRequired: "El kell fogadnia a Google Adatvédelmi irányelveit.",
      googleTermsOfServiceRequired: "El kell fogadja a Google Általános szerződési feltételeit.",
      leckePrivacyPolicyRequired: "El kell fogadja a Lecke Adatkezelési tájékoztatóját.",
    },
  },

  // Sent step
  sent: {
    title: "E-mail elküldve!",
    bodyPrefix: "Elküldtük az aktiváló e-mailt a(z)",
    bodySuffix: "címre. Keresse meg a postaládájában, és kattintson az aktiválási linkre.",
    backToLogin: "Vissza a bejelentkezéshez",
  },

  // Form fields
  form: {
    emailLabel: "Email cím",
    emailPlaceholder: "pelda@example.com",
    passwordLabel: "Jelszó",
    passwordPlaceholder: "••••••••",
    rememberMe: "Emlékezzen rám",
    submitButton: "Bejelentkezés",
    loadingButton: "Bejelentkezés...",
    enterPasswordFor: "Írja be a jelszavát ehhez a fiókhoz",
    editEmail: "Módosítás",
  },

  // External login (IdP)
  external: {
    divider: "más fiókkal",
    kreta: "Belépés Kréta-val",
    google: "Belépés Google-lel",
    loadingButton: "Átirányítás...",
  },

  // OAuth callback page
  callback: {
    loadingTitle: "Bejelentkezés folyamatban",
    loadingMessage: "Kérjük, várjon egy pillanatot, miközben befejezzük a bejelentkezést.",
    errorTitle: "Sikertelen bejelentkezés",
    missingParamsError: "Hiányzó azonosító paraméterek. Kérjük, próbálja újra.",
    backToLogin: "Vissza a bejelentkezéshez",
  },

  // Errors
  errors: {
    recaptchaFailed: "reCAPTCHA ellenőrzés sikertelen. Kérjük, próbálja újra.",
    invalidCredentials:
      "Helytelen email cím vagy jelszó. Kérjük, ellenőrizze az adatokat és próbálja újra.",
    accountTemporarilyLocked: "A fiók átmenetileg zárolva van. Próbálkozzon újra később.",
    accountPermanentlyLocked: "A fiók zárolva van. Keresse az adminisztrátort.",
    externalLoginFailed: {
      google: "Nem sikerült belépni Google fiókkal. Kérjük, próbálja újra.",
      kreta: "Nem sikerült belépni Kréta fiókkal. Kérjük, próbálja újra.",
      default: "Nem sikerült a külső bejelentkezés. Kérjük, próbálja újra.",
    },
  },

  // Success
  success: {
    title: "Sikeres bejelentkezés",
    message: "Sikeresen bejelentkezett. Bezárhatja ezt az ablakot.",
  },
} as const;

export type LoginMessages = typeof login;
